/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { LIST_GROUP_PARTICIPANTS } from "./actionTypes"
import { apiError, listGroupParticipantsSuccess } from "./actions"

//Include Both Helper File with needed methods
import { getGroupParticipants } from "../../../helpers/backend_helper"

function* list(request) {
  try {
    const response = yield call(getGroupParticipants, request.payload.id)
    if (response == undefined) throw new Error("API error")
    yield put(listGroupParticipantsSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* groupParticipantsListSaga() {
  yield takeEvery(LIST_GROUP_PARTICIPANTS, list)
}

export default groupParticipantsListSaga
